import { render, staticRenderFns } from "./topic_form.vue?vue&type=template&id=bfa4a276"
import script from "./topic_form.vue?vue&type=script&lang=js"
export * from "./topic_form.vue?vue&type=script&lang=js"
import style0 from "./topic_form.vue?vue&type=style&index=0&id=bfa4a276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports